import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from 'core/services';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class KeplerPlayerService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/kepler/players');
  }

  /**
   * Fetch of the kepler match list
   * @param options
   */
  public fetch$(options?: {
    page: number;
    limit: number;
    sort: string;
    search: string;
    filters: object;
    aggregates: string;
    populate: string;
  }): Observable<any> {
    return this.fetchRequest(this.baseUrl, options);
  }

  public getPlayer(player) {
    const url = `${this.baseUrl}/${player.id}`;

    return this.fetchRequest(url, this.getRequestOptions());
  }

  public anonymizePlayer(player) {
    const url = `${this.baseUrl}/${player.id}/anonymize`;

    return this.putRequest(url, JSON.stringify(player), this.getRequestOptions());
  }

  public deletePlayer(player) {
    const url = `${this.baseUrl}/${player.id}`;

    return this.deleteRequest(url, this.getRequestOptions());
  }

  public updatePlayer(player) {
    return this.putRequest(`${this.baseUrl}/${player.id}`, player, this.getRequestOptions());
  }

  public updatePlayersBulk(data) {
    return this.putRequest(this.baseUrl, data, this.getRequestOptions());
  }

  public createPlayersBulk(matchId: string, file: any, clientId: string) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    const params: HttpParams = new HttpParams({ fromObject: { clientId: clientId } });
    return lastValueFrom(this.http.post(`${this.baseUrl}/${matchId}`, formData, { params }))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  public getPlayerProgress(player, options?) {
    const url = `${this.baseUrl}/${player.id}/progress`;

    return this.fetchRequest(url, options);
  }

  public getPlayerTemplate(matchId) {
    const userLang = localStorage.getItem('backofficelanguage');

    return this.http.get(`${this.baseUrl}/${matchId}/csv-template?lang=${userLang}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
